const steps = [
  {
    n: "01",
    t: "Book a Visit",
    d: "Schedule online in under 60 seconds. We confirm the property address, gate codes and access window.",
    tint: "bg-teal-50",
    chip: "bg-teal-100 text-teal-800",
    num: "text-teal-700",
  },
  {
    n: "02",
    t: "On-Site Measure",
    d: "Our local technician scans the property with laser tools and reference photography. Around 30–60 minutes on site.",
    tint: "bg-amber-50",
    chip: "bg-amber-100 text-amber-800",
    num: "text-amber-700",
  },
  {
    n: "03",
    t: "Draft & Review",
    d: "Drafted to ANSI/REBAC standards with internal QA. You get a preview and 5 rounds of revisions included.",
    tint: "bg-rose-50",
    chip: "bg-rose-100 text-rose-800",
    num: "text-rose-700",
  },
  {
    n: "04",
    t: "Delivery",
    d: "Final files ready in 24–48h: PDF, PNG, DXF for architects, branded watermarks for agents.",
    tint: "bg-sky-50",
    chip: "bg-sky-100 text-sky-800",
    num: "text-sky-700",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      className="py-24 lg:py-32 px-6 lg:px-12 bg-[#FAF7F2] relative overflow-hidden"
      data-testid="process-section"
    >
      <div className="blob blob-sky w-[360px] h-[360px] -top-10 right-0" />
      <div className="relative mx-auto max-w-7xl">
        <div className="flex items-end justify-between mb-16 flex-wrap gap-6">
          <div>
            <span className="inline-block bg-white border border-stone-200 px-3 py-1.5 rounded-full text-xs font-semibold text-stone-700 mb-5">
              02 — How it works
            </span>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-stone-900 leading-[1.05]">
              Four steps.<br />
              <span className="italic font-medium text-teal-700">Zero friction.</span>
            </h2>
          </div>
          <p className="max-w-md text-stone-600 text-lg leading-relaxed">
            From the first call to final delivery — built to match the speed of
            a hot DMV market.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s) => (
            <div
              key={s.n}
              className={`p-8 ${s.tint} border border-stone-200 rounded-[2rem] hover:-translate-y-1 hover:shadow-lg transition-all duration-300`}
              data-testid={`process-step-${s.n}`}
            >
              <span className={`inline-block ${s.chip} px-3 py-1 rounded-full text-[11px] font-bold tracking-wider mb-5`}>
                STEP {s.n}
              </span>
              <div className={`font-display text-6xl font-semibold ${s.num} mb-4`}>
                {s.n}
              </div>
              <h3 className="font-display text-2xl font-semibold text-stone-900 mb-3">
                {s.t}
              </h3>
              <p className="text-stone-600 leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
